module.exports = __webpack_public_path__ + "static/media/mari_mobile1.7698f902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_mobile1.png
// module id = 94
// module chunks = 0